import React from "react";
import FullScreenLayout from "layouts/MainLayout/FullScreenLayout";
import { useTranslation } from "react-i18next";
import RulesList from "../features/RulesList";
import { RULES_USER_DOCS_URL } from "utils";
import { observer } from "mobx-react-lite";
import RuleOverview from "../features/RuleOverview";
import { rulesSetStore } from "../RulesSetStore";
import { LoadingView } from "components/LoadingView";
import { useParams } from "react-router";

const RulesEditor = () => {
  const { t } = useTranslation();
  const [showOverview, setShowOverview] = React.useState(true);
  const { organisation_id } = useParams();

  const closeOverview = () => setShowOverview(false);
  const hasValidationError = () => {
    return !rulesSetStore.checkConditionsValidation();
  };

  async function initList() {
    rulesSetStore.setLoading(true);
    rulesSetStore.setOrganisationID(organisation_id);
    await rulesSetStore.fetchProperties();
    await rulesSetStore.fetchRulesList();
    rulesSetStore.setLoading(false);
  }

  React.useEffect(() => {
    initList();
  }, [organisation_id]);

  React.useEffect(() => {
    return () => rulesSetStore.reset();
  }, []);

  return (
    <FullScreenLayout
      title={t("rulesEditor.ruleSetEditor")}
      helpURL={RULES_USER_DOCS_URL}
      closeButtonTitle={t("commons.done")}
      closeButtonAction={closeOverview}
      confirmTitle={t("rulesEditor.incompleteRulesTitle")}
      confirmMessage={t("rulesEditor.incompleteRulesDescription")}
      showConfirm={hasValidationError}
    >
      <div className="grid grid-cols-2 h-full">
        {rulesSetStore.loading ? (
          <LoadingView
            message={t("rulesEditor.loadingRules")}
            containerClassName="col-span-2 bg-gray-100"
            iconClassName="w-[80px] h-[80px]"
          />
        ) : (
          <>
            <RulesList
              showOverview={showOverview}
              setShowOverview={setShowOverview}
            />
            {showOverview && <RuleOverview close={closeOverview} />}
          </>
        )}
      </div>
    </FullScreenLayout>
  );
};

export default observer(RulesEditor);
